<template>
  <v-layout justify-center align-center>
    <v-flex xs12 sm10 md8 lg6>
      <form v-scroll-to-error @submit.prevent="submitForm">
        <v-layout wrap>
          <v-flex class="ml-12 mt-12 mb-50" xs12>
            <span class="primary-color form-title">{{
              (isAdminLocalization ? adminText('adminAll.forgot_password_5ed117', 'Forgot password') : $t('forgotPasswordPageHeader', 'Forgot password'))
            }}</span>
          </v-flex>
          <v-flex xs12>
            <recover-password-form :vs="$v" :initial-values="form" @values="form = $event" />
          </v-flex>
          <v-flex xs12>
            <main-button
              :text="(isAdminLocalization ? adminText('adminAll.change_password_8c6842', 'Change password') : $t('changePassword', 'Change password'))"
              depressed
              @click="$emit('submit')"
            />
          </v-flex>
        </v-layout>
      </form>
    </v-flex>
    <simple-snackbar v-bind.sync="snackbar" :message-prop="adminAllMessage(snackbar.messageProp)" />
  </v-layout>
</template>

<script>
import AdminAllMessages from '@/components/admin/AdminAllMessages'
import AdminContext from '@/admin-i18n/context'
import { RECOVER_PASSWORD } from '../../graphql/utils.graphql'
import SimpleSnackbar from '../shared/snackbars/simple-snackbar'
import RecoverPasswordForm from './recover-password-form.vue'
import MainButton from './../shared/main-button'
import { submitGuard } from './../../utils'

import { minLength, required, sameAs } from 'vuelidate/lib/validators'

export default {
  mixins: [AdminContext, AdminAllMessages],
  name: 'forgot-password-container',
  components: {
    RecoverPasswordForm,
    MainButton,
    SimpleSnackbar,
  },
  props: {
    token: String,
  },
  data: () => ({
    snackbar: {},
    form: {},
  }),
  validations: {
    form: {
      newPassword: { required, minLength: minLength(5) },
      repeatPassword: { required, sameAs: sameAs('newPassword') },
    },
  },
  methods: {
    async submitForm() {
      await submitGuard(this, async () => {
        const { errors } = await this.$apollo.mutate({
          mutation: RECOVER_PASSWORD,
          variables: {
            token: this.token,
            newPassword: this.form.newPassword,
          },
        })
        if (errors) {
          return (this.snackbar = {
            open: true,
            messageProp: this.adminAllNotice('Something went wrong'),
            color: 'error',
          })
        }
        await this.$apollo.provider.defaultClient.resetStore()
        this.goTo(this.routes.organizer.events)
      })
    },
  },
}
</script>

<style scoped></style>
